import { Box, Grid, Typography, makeStyles } from "@material-ui/core";
import { ShaDowBox } from "../../../../../components/boxes";
import { NoDataCard } from "../../../../../components/parts";
import { CustomPieChart } from "../../../../../components/charts";
import { useEffect, useState } from "react";
import { getData, getPercent } from "../../../../../services";
import { COLORS } from "../../../../../theme/colors";

const useStyles = makeStyles(() => ({
  grid: {
    marginTop: 24,
  },
  text: {
    fontWeight: 700,
    textAlign: "center",
    marginBottom: 30,
  },
  box: {
    height: 270,
  },
}));

export const ComplexElectricityConnectionStatus = ({ complex }) => {
  const classes = useStyles();
  const [data, setData] = useState(null);

  const valueFormat = (value, percent) => {
    return `${value} (${percent}%)`;
  };

  useEffect(() => {
    getData(`/praas/v2/complexes/${complex.id}/properties/connection-status/`, setChartData);
  }, [complex?.id]);

  const setChartData = (data) => {
    setData([
      {
        name: "Connected",
        value: data.connected,
        key: "connected",
        color: COLORS.green,
        unit: "%",
        value_percent: getPercent(data.connected, data.total),
        centerLabel: "are fully",
        centerSuffixLabel: "connected",
        valueFormat,
      },
      {
        name: "Ready to connect",
        value: data.ready_to_connect,
        key: "ready_to_connect",
        color: COLORS.purple,
        unit: "%",
        value_percent: getPercent(data.ready_to_connect, data.total),
        centerLabel: "are ready",
        centerSuffixLabel: "to connect",
        valueFormat,
      },
      {
        name: "Stand by",
        value: data.stand_by,
        key: "stand_by",
        color: COLORS.orange,
        unit: "%",
        value_percent: getPercent(data.stand_by, data.total),
        centerLabel: "are",
        centerSuffixLabel: "stand by",
        valueFormat,
      },
      {
        name: "Pending",
        value: data.pending,
        key: "pending",
        color: COLORS.blue,
        unit: "%",
        value_percent: getPercent(data.pending, data.total),
        centerLabel: "are",
        centerSuffixLabel: "pending",
        valueFormat,
      },
      {
        name: "Missing Info",
        value: data.missing_info,
        key: "missing_info",
        color: COLORS.red,
        unit: "%",
        value_percent: getPercent(data.missing_info, data.total),
        centerLabel: "are",
        centerSuffixLabel: "pending",
        valueFormat,
      },
    ]);
  };

  return (
    <ShaDowBox>
      <Box style={{ padding: 24 }}>
        <Typography variant="h4">Meters PRaaS-Connection Status</Typography>
        <Grid container className={classes.grid}>
          <Grid item xs={12}>
            {data ? (
              <Box className={classes.box}>
                <CustomPieChart name="ConnectionStatus" data={data} />
              </Box>
            ) : (
              <NoDataCard
                withShaDowBox={false}
                boxStyle={{ padding: 0 }}
                gridStyle={{ height: 170 }}
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </ShaDowBox>
  );
};
